import React, { useEffect, useRef, useState, useMemo } from "react";
import { Button, Checkbox, Tooltip } from "antd";
import { scroller } from "react-scroll";
import uuid from "react-uuid";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveSectionKey,
  setSections,
} from "../../../redux/actions/section/section";
import { setFetchSectionData } from "../../../redux/actions/ApiCall/apiCall";
import accoArrow from "../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import {
  callNotification,
  getPaneIndex,
  getPrivateConversationFilters,
  removePrivateConversationFilters,
  getPinnedTemplateDetails,
  setSelectedPillInShareTemplate,
} from "../../../redux/constants";
import {
  setActiveSectionId,
  setClearGraphData,
  updateDashboardSectionOpen,
} from "../../../redux/actions/dashboard/Tab1";
import informationButton from "../../../assets/information-button.svg";
import isEqual from "react-fast-compare";
import aiStars from "../../../assets/WidgetMaker/ai_stars-icon.svg";
import { CloseCircleOutlined } from "@ant-design/icons";
import quickfiltericon from "../../../assets/quick-filters-icon.svg";

const Section = ({
  //shareTemplateData,
  sections,
  container,
  isViewDashboard = false,
}) => {
  const dispatch = useDispatch();
  const activeSectionKey = useSelector(
    (state) => state.Section.activeSectionKey
  );
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  const [windowWidths, setWindowWidths] = useState(null);
  const newSection = useSelector((state) => state.Section.addSection);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  const sectionWrapperRef = useRef(null);
  const sectionListRef = useRef(null);
  let index = getPaneIndex(panes, activeKey);
  // variables for quick filter
  const selectedPill = shareTemplateData?.selected_pills
    ? shareTemplateData?.selected_pills
    : [];
  const [selectedTemplatePill, setSelectedTemplatePill] = useState(
    selectedPill?.[0] || null
  );
  const [showFullDescription, setShowFullDescription] = useState(false);
  const filterTemplates = shareTemplateData?.filter_templates;
  const pinnedFiltersIds = shareTemplateData?.pinned_filter_templates;
  const toshowPinnedTemplatePills = getPinnedTemplateDetails(
    filterTemplates,
    pinnedFiltersIds
  );
  const ScrollToElement = (element, containerId) => {
    scroller.scrollTo(element, {
      duration: 100,
      delay: 0,
      smooth: true,
      offset: -175,
    });
  };

  useEffect(() => {
    if (newSection?.name) {
      let myArr = sections;
      myArr.push({
        section_name: newSection?.name,
        section_id: uuid(),
        section_description: newSection?.description,
      });
      dispatch(setSections(sections));
    }
  }, [newSection]);

  useEffect(() => {
    if (authParams?.template_id) {
      if (activeSectionKey) {
        dispatch(setActiveSectionKey(activeSectionKey));
      } else if (panes[index]?.active_section_id) {
        dispatch(setActiveSectionKey(panes[index]?.active_section_id));
      } else if (
        panes[index]?.active_section_id !== sections?.[0]?.section_id
      ) {
        dispatch(setActiveSectionId(sections?.[0]?.section_id, panes, index));
        dispatch(setActiveSectionKey(sections?.[0]?.section_id));
      } else if (
        panes[index]?.active_section_id === sections?.[0]?.section_id
      ) {
        dispatch(setActiveSectionId(sections?.[0]?.section_id, panes, index));
        dispatch(setActiveSectionKey(sections?.[0]?.section_id));
      }
    } else {
      if (activeSectionKey) {
        dispatch(setActiveSectionKey(activeSectionKey));
      } else if (panes[index]?.active_section_id) {
        dispatch(setActiveSectionKey(panes[index]?.active_section_id));
      } else if (!panes[index]?.active_section_id) {
        dispatch(setActiveSectionId(sections?.[0]?.section_id, panes, index));
        dispatch(setActiveSectionKey(sections?.[0]?.section_id));
      } else if (
        panes[index]?.active_section_id === sections?.[0]?.section_id
      ) {
        dispatch(setActiveSectionKey(sections?.[0]?.section_id));
        dispatch(setActiveSectionId(sections?.[0]?.section_id, panes, index));
      } else {
        dispatch(setActiveSectionKey(sections?.[0]?.section_id));
      }
    }
  }, [sections]);

  let scrollBarWidths = 40;

  const getLeftPosi = () => {
    if (sectionListRef?.current?.getBoundingClientRect()) {
      return sectionListRef?.current?.getBoundingClientRect()?.left;
    } else {
      return 0;
    }
  };
  const widthOfList = () => {
    let itemsWidth = 0;
    if (sectionListRef?.current) {
      sectionListRef?.current?.childNodes?.forEach((element) => {
        itemsWidth += element?.clientWidth + 10;
      });
    }
    return itemsWidth;
  };
  const widthOfHidden = () => {
    if (sectionWrapperRef?.current) {
      return (
        sectionWrapperRef?.current?.getBoundingClientRect()?.width -
        widthOfList() -
        getLeftPosi() -
        scrollBarWidths
      );
    } else {
      return 0;
    }
  };
  const setWindowDimensions = () => {
    setWindowWidths(window.innerWidth);
    widthOfHidden();
  };
  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  useEffect(() => {
    const scrollContainer = document.querySelector(".carouselContainer");
    scrollContainer?.addEventListener("wheel", (evt) => {
      evt.preventDefault();
      scrollContainer.scrollLeft += evt.deltaY;
    });
    return () => {
      scrollContainer?.removeEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollContainer.scrollLeft += evt.deltaY;
      });
    };
  }, []);

  const prevPills = () => {
    requestAnimationFrame(() => {
      const scrollLeft = sectionListRef.current.scrollLeft;
      const itemWidth = parseInt(
        getComputedStyle(sectionListRef.current.children[0]).width
      );
      sectionListRef.current.scrollLeft = scrollLeft - itemWidth * 2;
    });
  };
  const nextPills = () => {
    requestAnimationFrame(() => {
      const scrollLeft = sectionListRef.current.scrollLeft;
      const itemWidth = parseInt(
        getComputedStyle(sectionListRef.current.children[0]).width
      );
      sectionListRef.current.scrollLeft = scrollLeft + itemWidth * 2;
    });
  };
  const handleOnSectionClick = (event, w) => {
    const ClickBtnWidth = widthOfHidden() + widthOfList() - w?.pageX;
    if (w?.pageX <= 100) {
      prevPills();
    } else if (ClickBtnWidth <= 230) {
      nextPills();
    }
    //add widgetMaker code
    dispatch(setActiveSectionKey(event?.section_id));

    // add section key in panes
    dispatch(setActiveSectionId(event?.section_id, panes, index));

    ScrollToElement(event?.section_id, container);
    let params = {
      panes: panes,
      activeKey: activeKey,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      singleBrands: brands,
      graphConditionConfig: graphConditionConfig,
    };
    let paneIndex = getPaneIndex(panes, activeKey);
    !event?.widgets &&
      authParams &&
      dispatch(
        setFetchSectionData(
          authParams,
          event?.section_id,
          params,
          panes[paneIndex]?.template_id
        )
      );

    let section_index;
    sections?.map((el, i) => {
      if (el?.section_id === event?.section_id) {
        section_index = i;
      }
    });
    if (!shareTemplateData)
      dispatch(
        updateDashboardSectionOpen(true, paneIndex, panes, section_index)
      );
    else if (shareTemplateData) {
      let updateShareTemplateData = { ...shareTemplateData };

      if (updateShareTemplateData?.sections) {
        updateShareTemplateData.sections[section_index].open = true;
      }
      dispatch({
        type: "SET_SHARE_TEMPLATE_DATA",
        payload: updateShareTemplateData,
      });
    }
  };

  const handleCheckbox = (e) => {
    window.stop();
    let updateShareTemplateData = { ...shareTemplateData };
    if (e.target.checked) {
      let filters = removePrivateConversationFilters(
        shareTemplateData?.comp_hidden_filter,
        shareTemplateData?.filters ? shareTemplateData?.filters : [],
        shareTemplateData?.saved_filters
      );
      updateShareTemplateData.filters = filters;
      updateShareTemplateData.private_conversation = true;
      let shareObj = {
        shareBrands: shareBrands,
        shareData: shareTemplateData,
        shareCategory: shareCategory,
        graphConditionConfig: graphConditionConfig,
        change_type: "global_duration",
      };

      dispatch(setClearGraphData(null, null, "share", shareObj));
      callNotification(
        "Filters updated by including Private conversations",
        "info"
      );
    } else if (!e.target.checked) {
      let filters = getPrivateConversationFilters(
        shareTemplateData?.comp_hidden_filter,
        shareTemplateData?.filters ? shareTemplateData?.filters : []
      );

      updateShareTemplateData.filters = filters;
      updateShareTemplateData.private_conversation = false;
      let shareObj = {
        shareBrands: shareBrands,
        shareData: shareTemplateData,
        shareCategory: shareCategory,
        graphConditionConfig: graphConditionConfig,
        change_type: "global_duration",
      };

      dispatch(setClearGraphData(null, null, "share", shareObj));
      callNotification(
        "Filters updated by excluding Private conversations",
        "info"
      );
    }
    dispatch({
      type: "SET_SHARE_TEMPLATE_DATA",
      payload: updateShareTemplateData,
    });
  };

  const handlePublicEngagementCheckbox = (e) => {
    window.stop();
    let updateShareTemplateData = { ...shareTemplateData };
    if (e.target.checked) {
      updateShareTemplateData.public_engagement_only = true;
      let shareObj = {
        shareBrands: shareBrands,
        shareData: shareTemplateData,
        shareCategory: shareCategory,
        graphConditionConfig: graphConditionConfig,
        change_type: "global_profile",
      };

      dispatch(setClearGraphData(null, null, "global_changes", shareObj));
      callNotification("Widgets updated", "info");
    } else if (!e.target.checked) {
      updateShareTemplateData.public_engagement_only = false;
      let shareObj = {
        shareBrands: shareBrands,
        shareData: shareTemplateData,
        shareCategory: shareCategory,
        graphConditionConfig: graphConditionConfig,
        change_type: "global_profile",
      };

      dispatch(setClearGraphData(null, null, "global_changes", shareObj));
      callNotification("Widgets updated", "info");
    }
    dispatch({
      type: "SET_SHARE_TEMPLATE_DATA",
      payload: updateShareTemplateData,
    });
  };

  // quick filter functions
  const handlePillDetails = (template) => {
    let newShareTemplateData = {};
    if (
      selectedTemplatePill?.filter_template_id === template?.filter_template_id
    ) {
      setSelectedTemplatePill(null);
      // for de-selecting quick filter pill
      newShareTemplateData = setSelectedPillInShareTemplate(
        {},
        shareTemplateData
      );
    } else {
      setSelectedTemplatePill(template);
      // for selecting quick filter pill
      newShareTemplateData = setSelectedPillInShareTemplate(
        template,
        shareTemplateData
      );
    }

    // Delay shareObj creation and final dispatch by 1000ms
    let shareObj = {
      shareBrands: shareBrands,
      shareData: newShareTemplateData,
      shareCategory: shareCategory,
      graphConditionConfig: graphConditionConfig,
    };
    dispatch(setClearGraphData(null, null, "share", shareObj));
  };

  const handleShowDescription = () => {
    setShowFullDescription(!showFullDescription);
  };
  return (
    <div className="deep_dive_tab section bg__white">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          {shareTemplateData?.title && (
            <div
              className={`text_heading-Slab font-size16 font-weight500 ${
                shareTemplateData?.description ? "" : "mb-15"
              }`}
            >
              {shareTemplateData?.is_ai_dashboard ? (
                <>
                  <img src={aiStars} style={{ marginRight: "0.5rem" }} />
                </>
              ) : (
                ""
              )}{" "}
              {shareTemplateData?.title}
            </div>
          )}
          {shareTemplateData?.description && (
            <div
              className={`text_regular text__ellipsis-line2 ${
                !sections || sections?.length === 0 ? " mb-1 " : " mb-15 "
              }`}
            >
              {shareTemplateData?.description}
            </div>
          )}
        </div>
        {shareTemplateData?.template_type === "competition" && (
          <div
            className={`text_heading-Slab font-size16 mr-3 ${
              shareTemplateData?.dashboard_called_api_list?.length > 0
                ? "disable"
                : ""
            }`}
            // className="text_heading-Slab font-size16 mr-3"
          >
            {!(share_workspace_privileges?.environment === 2) ? (
              <Checkbox
                onChange={(e) => handlePublicEngagementCheckbox(e)}
                checked={shareTemplateData?.public_engagement_only}
              >
                Public Engagement
                <Tooltip
                  overlayInnerStyle={{
                    borderRadius: "0.7rem",
                    marginLeft: "-35rem",
                  }}
                  // placement="bottomLeft"
                  title={
                    <span>
                      {shareTemplateData?.public_engagement_only
                        ? "Uncheck to include other owned metrics in Engagement "
                        : "Check to exclude owned metrics in Engagement  "}
                    </span>
                  }
                >
                  <img
                    src={informationButton}
                    alt="Info"
                    className="cursor-pointer ml-2"
                    style={{ maxWidth: "1.6rem" }}
                  />
                </Tooltip>
              </Checkbox>
            ) : (
              ""
            )}

            <Checkbox
              onChange={(e) => handleCheckbox(e)}
              checked={shareTemplateData?.private_conversation}
            >
              {shareTemplateData?.private_conversation
                ? "Includes Private Conversations"
                : "Include Private Conversations"}
              <Tooltip
                overlayInnerStyle={{
                  width: "45rem",
                  borderRadius: "0.7rem",
                  marginLeft: "-35rem",
                  marginRight: "3rem",
                }}
                // placement="bottomLeft"
                title={
                  <>
                    <div
                      style={{
                        fontWeight: "bold",
                        marginBottom: "0.5rem",
                      }}
                    >
                      Include Private Conversations
                    </div>
                    <ul
                      style={{
                        paddingLeft: "2.2rem",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <li>
                        Surface DMs, dark posts, Email threads and LinkedIn
                        messages
                      </li>
                      <li>Exclude when benchmarking competitors</li>
                      <li>Include when comparing your own brands</li>
                    </ul>
                    {/* <span>
                      Check this to
                      {shareTemplateData?.private_conversation
                        ? " exclude "
                        : " include "}
                      Private conversations such as DMs, dark posts and channels
                      like email and Linkedin.
                      <br />
                      For Benchmarking against the competition, use this with an
                      exclusion.
                      <br />
                      For comparing your own brands, use this with inclusion.
                    </span> */}
                  </>
                }
              >
                <img
                  src={informationButton}
                  alt="Info"
                  className="cursor-pointer ml-2"
                  style={{ maxWidth: "1.6rem" }}
                />
              </Tooltip>
            </Checkbox>
          </div>
        )}
      </div>
      {shareTemplateData && shareTemplateData?.filter_templates && (
        <div
          style={{
            gap: "1.6rem",
          }}
          className={`${"QuickFilterList d-flex flex-wrap align-items-center mr-3 mb-3"}${
            shareTemplateData?.sections?.length ? " quick-pt-10" : " quick-pb-8"
          }`}
        >
          {toshowPinnedTemplatePills?.map((template, index) => (
            <div
              key={index}
              className={`QuickFilterList__item ${
                selectedTemplatePill?.filter_template_id ===
                template?.filter_template_id
                  ? "selected"
                  : ""
              }`}
            >
              <Tooltip
                overlayStyle={{
                  width: "30rem",
                }}
                overlayInnerStyle={{
                  padding: "0.8rem",
                  borderRadius: "0.8rem",
                }}
                overlayClassName="QuickFilterList__Tooltip"
                color="#fff"
                onOpenChange={() => setShowFullDescription(false)}
                title={
                  <>
                    <div className="mb-1">
                      <div className="mb-2">
                        <>
                          {" "}
                          <p className="mb-0 pb-0">
                            <span
                              style={{
                                color: "#3b5175",
                                fontSize: "1.5rem",
                              }}
                              className="text-transform__capitalize"
                            >
                              <strong>{template?.filter_template_name}</strong>
                            </span>
                          </p>
                        </>
                        {template?.filter_template_description?.trim() ? (
                          <>
                            <span
                              style={{
                                color: "#3b5175",
                              }}
                              className="d-flex justify-content-between align-items-center"
                            >
                              {template?.filter_template_description?.length >
                              25 ? (
                                <>
                                  {!showFullDescription ? (
                                    <>
                                      <span style={{ maxWidth: "16.3rem" }}>
                                        {template?.filter_template_description?.slice(
                                          0,
                                          20
                                        )}
                                      </span>
                                      <span
                                        style={{
                                          color: "#185edf",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => handleShowDescription()}
                                      >
                                        See more...
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <div style={{ wordBreak: "break-word" }}>
                                        <span>
                                          {
                                            template?.filter_template_description
                                          }
                                          <span
                                            style={{
                                              color: "#185edf",
                                              cursor: "pointer",
                                              display: "flex",
                                            }}
                                            onClick={() =>
                                              handleShowDescription()
                                            }
                                          >
                                            See less
                                          </span>
                                        </span>
                                      </div>
                                    </>
                                  )}
                                </>
                              ) : (
                                template?.filter_template_description
                              )}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        <hr
                          style={{
                            backgroundColor: "#185edf1a",
                            margin: "0.8rem 0",
                          }}
                        />
                      </div>
                    </div>

                    {/* saved filter here refers filter inside quick filter pill */}
                    {template?.saved_filters?.length > 0 ? (
                      <div
                        className="custom_scroll_quickfilter_header_tooltip"
                        style={{
                          maxWidth: "27rem",
                          maxHeight: "23rem",
                          overflow: "auto",
                          scrollBehavior: "smooth",
                        }}
                      >
                        <div className="mb-1">
                          {template?.saved_filters?.map((el, mappedIndex) => {
                            let data =
                              shareTemplateData?.filterPanelData?.[
                                el?.attribute
                              ]?.values;

                            return !(
                              shareTemplateData?.template_id ===
                                "000-000-002" ||
                              shareTemplateData?.template_id === "000-000-003"
                            ) ? (
                              template?.saved_filters?.length ? (
                                <div className="mb-2" key={mappedIndex}>
                                  <p
                                    className="mb-0"
                                    style={{
                                      color: "#3b5175",
                                    }}
                                  >
                                    <strong>
                                      {All_Share_attributes
                                        ? All_Share_attributes?.[el?.attribute]
                                          ? All_Share_attributes?.[
                                              el?.attribute
                                            ]
                                          : el?.attribute?.toLowerCase() ===
                                            "categoryid"
                                          ? "Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subcategoryid_aug"
                                          ? "Sub Category"
                                          : el?.attribute?.toLowerCase() ===
                                            "subsubcategoryid"
                                          ? "Sub Sub Category"
                                          : el?.attribute?.endsWith("ID")
                                          ? el?.attribute?.replace("ID", "")
                                          : el?.attribute?.replace("Type", "")
                                        : el?.attribute?.endsWith("ID")
                                        ? el?.attribute?.replace("ID", "")
                                        : el?.attribute?.replace("Type", "")}
                                    </strong>
                                  </p>
                                  {el?.type === "int" &&
                                    !Array.isArray(el?.columns) && (
                                      <span
                                        // className="font-weight-light text-white"
                                        style={{ color: "#3b5175" }}
                                      >
                                        {el?.columns?.from +
                                          " - " +
                                          el?.columns?.to}
                                      </span>
                                    )}
                                  {Array.isArray(el?.columns) &&
                                    el?.columns?.map((e, index) => {
                                      return (
                                        <span
                                          className={
                                            e?.type === "exclude"
                                              ? " font-weight500"
                                              : " font-weight400"
                                          }
                                          style={{
                                            color:
                                              e?.type === "include"
                                                ? "#5ed66d"
                                                : e?.type === "exclude"
                                                ? "#fb7665"
                                                : "#3b5175",
                                          }}
                                        >
                                          {(index ? ", " : "") +
                                            (e?.display_name
                                              ? e?.display_name
                                              : e?.name)}
                                        </span>
                                      );
                                    })}
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              <div className="mb-2">
                                <p className="mb-0 text-white">
                                  <strong>
                                    {shareTemplateData?.template_id ===
                                      "000-000-003" &&
                                    el?.attribute === "IsWorkingHour"
                                      ? "Is Working Hour"
                                      : All_Share_attributes &&
                                        All_Share_attributes[el?.attribute]
                                      ? All_Share_attributes[el?.attribute]
                                      : shareTemplateData?.filterPanelData
                                      ? shareTemplateData?.filterPanelData?.[
                                          el?.attribute
                                        ]?.title
                                      : el?.attribute?.toLowerCase() ===
                                        "categoryid"
                                      ? "Category"
                                      : el?.attribute?.toLowerCase() ===
                                        "subcategoryid_aug"
                                      ? "Sub Category"
                                      : el?.attribute?.toLowerCase() ===
                                        "subsubcategoryid"
                                      ? "Sub Sub Category"
                                      : el?.attribute?.replace("Type", "")}
                                  </strong>
                                </p>
                                {Array.isArray(el?.columns) &&
                                  el?.columns?.map((e, index) => {
                                    return (
                                      <span
                                        className={
                                          e?.type === "exclude"
                                            ? " font-weight500"
                                            : " font-weight400"
                                        }
                                        style={{
                                          color:
                                            e?.type === "include"
                                              ? "#5ed66d"
                                              : e?.type === "exclude"
                                              ? "#fb7665"
                                              : "#3b5175",
                                        }}
                                      >
                                        {[
                                          "FeedBackEnabled",
                                          "ShowDeletedFromSocial",
                                          "AutoClosureEnabled",
                                          "IsWorkingHour",
                                        ]?.includes(el?.attribute)
                                          ? e?.name === null
                                            ? "Any"
                                            : e?.name === 0
                                            ? "No"
                                            : e?.name === 1 && "Yes"
                                          : (index ? ", " : "") +
                                            data?.filter(
                                              (g) => e?.name === g?.id
                                            )[0]?.name}
                                      </span>
                                    );
                                  })}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                }
                placement="bottom"
              >
                <span
                  className="QuickFilterList__item--pill"
                  onClick={() => handlePillDetails(template)}
                >
                  <img src={quickfiltericon} alt="ticked-icon" />
                  <span
                    // style={{ fontWeight: "400", marginRight: "0rem" }}
                    className="QuickFilterList__item--pillItem section__btn line-height-normal  box-shadow-none p-10"
                  >
                    <strong>
                      {template?.filter_template_name?.length > 25
                        ? template?.filter_template_name.slice(0, 25)
                        : template?.filter_template_name}
                    </strong>
                  </span>
                </span>
              </Tooltip>
              <Tooltip
                overlayStyle={{
                  width: "18rem",
                }}
                color="#3B5175"
                title={
                  <div
                    className="custom_scroll"
                    style={{
                      maxWidth: "27rem",
                      maxHeight: "23rem",
                      overflow: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <div className="mb-1">
                      <div className="mb-2">
                        <p className="mb-0 pb-0 text-white">
                          Remove the quick filter
                        </p>
                      </div>
                    </div>
                  </div>
                }
                placement="rightTop"
              >
                <div
                  className={
                    selectedPill?.[0]?.filter_template_id ===
                    template?.filter_template_id
                      ? "close-icon-pill"
                      : ""
                  }
                  onClick={() => handlePillDetails(template)}
                >
                  {selectedPill?.[0]?.filter_template_id ===
                    template?.filter_template_id && (
                    <CloseCircleOutlined
                      className="QuickFilterList__cloaseIcon"
                      // style={{ fontSize: "2rem", color: "#3b5175" }}
                    />
                  )}
                </div>
              </Tooltip>
            </div>
          ))}
        </div>
      )}
      {sections &&
        sections?.length > 0 &&
        (isViewDashboard
          ? (panes?.[index]?.quick_filter &&
              panes?.[index]?.profiles?.length === 0) ||
            (panes?.[index]?.is_ai_dashboard && !panes?.[index]?.is_ai_access)
            ? false
            : true
          : true) && (
          <div className="d-flex align-items-center">
            {widthOfHidden() < 0 && (
              <button
                className={`border-0 scroller`}
                onClick={prevPills}
                style={{ backgroundColor: "transparent" }}
              >
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  className="accordionArrow p-0"
                  alt="accoArrow"
                  style={{ transform: "rotate(270deg)" }}
                />
              </button>
            )}
            <div className="section__wrapper" ref={sectionWrapperRef}>
              <div
                className="section__wrapper--list carouselContainer"
                ref={sectionListRef}
              >
                {sections &&
                  sections?.map((item, i) => (
                    <>
                      <Button
                        key={i}
                        id={`tab_items_${item.section_id}`}
                        className={`section__btn line-height-normal tab_items box-shadow-none ${
                          item?.section_id === activeSectionKey ? "active" : ""
                        }`}
                        onClick={(e) => handleOnSectionClick(item, e)}
                        style={{
                          color:
                            activeSectionKey !== item?.section_id && "#3b5175",
                        }}
                      >
                        <Tooltip placement="topLeft" title={item?.section_name}>
                          <span className="section_btn">
                            {item?.section_name}
                          </span>
                        </Tooltip>
                      </Button>
                    </>
                  ))}
              </div>
            </div>
            {widthOfHidden() < 0 && (
              <button
                style={{ backgroundColor: "transparent" }}
                className={`border-0 scroller`}
                onClick={nextPills}
              >
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  className="accordionArrow p-0"
                  alt="accoArrow"
                  style={{ transform: "rotate(90deg)" }}
                />
              </button>
            )}
          </div>
        )}
    </div>
  );
};

export default React.memo(Section, isEqual);
